module.exports = __webpack_public_path__ + "static/Freight-BigLightItalic-829d5e010317cc4ad7e29cecbdc5b17e.woff2";